import { IconButton } from '@pypestream/design-system';
import { useGenericPopover } from '../generic-popover';
import {
  SolutionTypePopover,
  SolutionTypePopoverProps,
} from './solution-type-popover';

export const useSolutionTypePopover = ({
  disabled,
  onClose,
  ...restProps
}: Partial<SolutionTypePopoverProps>) => {
  const { onClose: onClosePopover, trigger, popoverRef } = useGenericPopover();

  const solutionTypePopoverTriggerButton = (
    <IconButton
      disabled={disabled}
      test-id="solution-settings-button"
      name="settings"
      id={trigger}
    />
  );

  const solutionTypePopover = (
    <SolutionTypePopover
      {...restProps}
      trigger={trigger}
      popoverRef={popoverRef}
      onClose={() => {
        onClosePopover();
        onClose?.();
      }}
    />
  );

  return {
    solutionTypePopover,
    solutionTypePopoverTriggerButton,
  };
};
